<template>
    <TransactionDetailWindowComponent v-if="transactionDetailWindowIsOpened" v-model:transactionDetailWindowIsOpened="transactionDetailWindowIsOpened" :currentTransaction="currentTransaction" :customZ="60" :withDeleteButton="false" />

    <div class="">
        <div class="fixed bg-gray-500 opacity-50 min-h-screen min-w-screen h-full w-full top-0 left-0 right-0 z-40"></div>
        <div @click="closeClientHistoryWindow" class="fixed top-0 left-0 right-0 w-full h-full flex items-center justify-center z-50">
            <div @click.stop ref="referenceWindowContent" class="relative flex flex-col justify-between bg-white z-50 max-h-[95vh] w-[80vw] rounded-lg py-10 px-16 overflow-y-scroll no-scrollbar">
                <svg @click="closeClientHistoryWindow" class="w-8 h-8 absolute top-[10px] right-[12px] text-gray-500 cursor-pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"/></svg>
                <div>
                    <p class="text-2xl mb-8">История покупок клиента</p>
                    <div class="flex flex-col items-stretch gap-8">
                        <div v-if="!$globalMethods.isEmptyObject(totalPaymentsValues)">
                            <label for="client-total-payment" class="mb-1 block text-sm text-gray-500">Сумма покупок</label>
                            <div class="grid grid-cols-3 gap-4">
                                <PriceInput v-for="(value, currency) in totalPaymentsValues" :key="currency" ref="addClientTotalPaymentsInput" :priceParam="value" :priceCurrency="currency" :readOnly="true"/>
                            </div>
                        </div>
                        <div class="border rounded">
                            <table class="w-full text-sm text-left rtl:text-right text-gray-500">
                                <thead class="rounded text-sm text-gray-700 bg-white">
                                    <tr class="border-b border-gray-300">
                                        <th scope="col" class="px-4 py-3">
                                            <span class="font-normal">Дата</span>
                                        </th>
                                        <th scope="col" class="px-4 py-3">
                                            <span class="font-normal">Наименование</span>
                                        </th>
                                        <th scope="col" class="px-4 py-3">
                                            <span class="font-normal">Кассир</span>
                                        </th>
                                        <th scope="col" class="px-4 py-3">
                                            <span style="font-weight: 400">Скидка</span>
                                        </th>
                                        <th scope="col" class="px-4 py-3">
                                            <span class="font-normal">Сумма</span>
                                        </th>
                                        <th scope="col" class="px-4 py-3">
                                            <span class="font-normal">Метод</span>
                                        </th>
                                        <th scope="col" class="px-4 py-3">
                                            <span class="font-normal">Касса</span>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody class="text-sm">
                                    <tr v-if="currentClientHistory.length == 0">
                                        <td colspan="7" class="px-4 py-2 text-center text-black">У этого клиента еще нет покупок</td>
                                    </tr>
                                    <tr v-for="transaction in currentClientHistory" :key="transaction.id" @click="openTransactionDetailWindow(transaction)" :class="transaction.is_active || transaction.transfer_to ? 'bg-white hover:bg-gray-50 text-black' : 'bg-[#f2d0db] hover:bg-red-50 text-black/60'" class="font-normal border-b">
                                        <td class="px-4 py-2 whitespace-nowrap">{{  this.$globalMethods.formatDateTime(transaction.date_of_created.split("+")[0]) }}</td>
                                        <td class="px-4 py-2" v-if="transaction.operations" :class="transaction.is_active ? '' : 'line-through'">{{ getNameByOperations(transaction.operations) }}</td>
                                        <td class="px-4 py-2" v-else-if="transaction.total < 0">{{ `Перевод в кассу "${transaction.transfer_to.name}"` }}</td>
                                        <td class="px-4 py-2" v-else>{{ `Перевод из кассы "${transaction.transfer_to.name}"` }}</td>
                                        <td class="px-4 py-2 whitespace-nowrap">{{ transaction.cashier.name }}</td>
                                        <td class="px-4 py-2 whitespace-nowrap">{{ transaction.discount ? `${Number(transaction.discount)}%`: "-" }}</td>
                                        <td v-if="transaction.total >= 0" class="px-4 py-2 whitespace-nowrap">
                                            <span>+{{ this.$globalMethods.formatNumberWithSpaces(transaction.total) }}</span>
                                            <span>{{ labels.currencies[transaction.currency] }}</span>
                                        </td>
                                        <td v-else class="text-red-500 px-4 py-2 whitespace-nowrap">
                                            <span>{{ this.$globalMethods.formatNumberWithSpaces(transaction.total) }}</span>
                                            <span>{{ labels.currencies[transaction.currency] }}</span>
                                        </td>
                                        <td class="px-4 py-2 whitespace-nowrap">{{ transaction.payment ? labels.transactionMethods[transaction.payment] : 'Наличные' }}</td>
                                        <td class="px-4 py-2 whitespace-nowrap overflow-hidden text-ellipsis max-w-[10rem]">{{ transaction.shop_name }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Decimal from 'decimal.js'; 
    import { mapState } from 'vuex';

    import PriceInput from '@/components/InputComponents/PriceInput.vue';
    import TransactionDetailWindowComponent from "@/components/laptop/Kassa/TransactionDetailWindowComponent.vue"

    export default {
        name: "ClientHistoryWindow",
        components: {
            PriceInput,
            TransactionDetailWindowComponent,
        },
        props: {
            clientHistoryWindowIsOpened: {
                type: Boolean,
                required: true,
            },
            currentClient: {
                type: Object,
                required: true,
            },
        },
        computed: {
            ...mapState(["labels", "currentClientHistory"]),
            totalPaymentsValues() {
                let result = {};
                for (const [currency, value] of Object.entries(this.currentClient.total_payments)) {
                    if (value) {
                        result[currency] = value;
                    }
                }
                return result;
            },
        },
        data() {
            return {
                currentTransaction: null,
                transactionDetailWindowIsOpened: false,
            }
        },
        methods: {
            openTransactionDetailWindow(transaction) {
                document.body.classList.add("overflow-hidden");
                this.currentTransaction = transaction;
                if (this.currentTransaction.discount && Number(this.currentTransaction.discount) != 0) {
                    this.currentTransaction.totalWithoutDiscount = this.caluclateTotalByOperations(this.currentTransaction.operations);
                }
                this.transactionDetailWindowIsOpened = true;
            },
            caluclateTotalByOperations(operations) {
                let result = new Decimal(0);
                for (const operation of operations) {
                    const operationTotalPrice = new Decimal(operation.price_without_discount).mul(operation.amount);
                    result = result.plus(operationTotalPrice);
                }
                return Number(result.toString());
            },
            getNameByOperations(operations) {
                if (operations.length == 0) {
                    return "-";
                }
                if (operations.length == 1) {
                    return operations[0].good.name;
                }
                return `${operations[0].good.name}, ...`;
            },
            closeClientHistoryWindow() {
                document.body.classList.remove("overflow-hidden");
                this.$emit("update:clientHistoryWindowIsOpened", false);
            },
            async loadData() {
                await this.$store.dispatch("fetchClientHistory", this.currentClient.id);
            },
        },
        created() {
            this.loadData();
        }
    }
</script>